import React from 'react';

import colors from '../sl-colors';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

export default function Eye({ color = colors.gray['400'], ...props }: Props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.29102 9.99984C2.29102 9.71783 2.40416 9.24603 2.70211 8.67396C2.99422 8.1131 3.44484 7.49367 4.06911 6.91742C5.31016 5.77184 7.24295 4.7915 9.99935 4.7915C12.7558 4.7915 14.6885 5.77184 15.9296 6.91742C16.5539 7.49367 17.0045 8.1131 17.2966 8.67396C17.5945 9.24603 17.7077 9.71783 17.7077 9.99984C17.7077 10.2818 17.5945 10.7536 17.2966 11.3257C17.0045 11.8866 16.5539 12.506 15.9296 13.0823C14.6885 14.2278 12.7558 15.2082 9.99935 15.2082C7.24295 15.2082 5.31016 14.2278 4.06911 13.0823C3.44484 12.506 2.99422 11.8866 2.70211 11.3257C2.40416 10.7536 2.29102 10.2818 2.29102 9.99984ZM9.99935 3.5415C6.92242 3.5415 4.68854 4.6445 3.22126 5.99892C2.49136 6.67267 1.95239 7.40741 1.59347 8.09655C1.24037 8.77448 1.04102 9.44851 1.04102 9.99984C1.04102 10.5512 1.24037 11.2252 1.59347 11.9031C1.95239 12.5923 2.49136 13.327 3.22126 14.0008C4.68854 15.3552 6.92242 16.4582 9.99935 16.4582C13.0763 16.4582 15.3102 15.3552 16.7774 14.0008C17.5073 13.327 18.0463 12.5923 18.4052 11.9031C18.7583 11.2252 18.9577 10.5512 18.9577 9.99984C18.9577 9.44851 18.7583 8.77448 18.4052 8.09655C18.0463 7.40741 17.5073 6.67267 16.7774 5.99892C15.3102 4.6445 13.0763 3.5415 9.99935 3.5415ZM8.12427 9.99986C8.12427 8.96432 8.96373 8.12486 9.99927 8.12486C11.0348 8.12486 11.8743 8.96432 11.8743 9.99986C11.8743 11.0354 11.0348 11.8749 9.99927 11.8749C8.96373 11.8749 8.12427 11.0354 8.12427 9.99986ZM9.99927 6.87486C8.27338 6.87486 6.87427 8.27397 6.87427 9.99986C6.87427 11.7257 8.27338 13.1249 9.99927 13.1249C11.7252 13.1249 13.1243 11.7257 13.1243 9.99986C13.1243 8.27397 11.7252 6.87486 9.99927 6.87486Z"
        fill={color}
      />
    </svg>
  );
}
